import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { Skeleton } from 'antd';
import routeConfig from './base';

export default function Index() {
  return (<Suspense fallback={<Skeleton />}>{useRoutes(routeConfig)}</Suspense>);
}
